import { render } from "./Equipamentos.vue?vue&type=template&id=6f4f3382&scoped=true"
import script from "./Equipamentos.vue?vue&type=script&lang=js"
export * from "./Equipamentos.vue?vue&type=script&lang=js"

import "./Equipamentos.vue?vue&type=style&index=0&id=6f4f3382&scoped=true&lang=scss"

import exportComponent from "/run/media/ctis-dev/developer/WorkSpaceFront/sgp-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4f3382"]])

export default __exports__